import React from 'react';
import { TableRow, TableCell, Tooltip } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
const Role = ({item, onRoleDetail}) => {
  return(
    <TableRow hover tabIndex={-1}>
      <TableCell>{item.name  == 'MR Calculator View' ? 'CommVerge View' : item.name =='MR Calculator Manager' ? 'CommVerge Manager' : item.name }</TableCell>
      <TableCell>{item.users_count}</TableCell>
      <TableCell className="actions-cell">
        <Tooltip title="View" arrow placement='top'>
          <VisibilityIcon onClick={onRoleDetail} color="primary" />
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}
export default Role;
